/* [04] / Black Friday Homepage Preview. Gate with ?bf04=1.
   No prices, purchase confirmations or faux customer counters on the homepage. */
(()=>{'use strict';
const params=new URLSearchParams(window.location.search);
if(params.get('bf04')!=='1')return;
if(window.location.pathname!=='/')return;
const root=document.querySelector('[data-bf04-home-hero]');
if(!root)return;
document.documentElement.setAttribute('data-bf04-home','preview');
root.hidden=false;
const enter=root.querySelector('[data-bf04-enter]');
if(enter){
 try{
  const url=new URL(enter.getAttribute('href'),location.origin);
  // This is a demonstration: the Waiting Room must stay in simulation mode.
  if(url.origin===location.origin){
   url.searchParams.set('sim','1');
   url.searchParams.set('fcfs04','1');
   const theme=new URLSearchParams(location.search).get('preview_theme_id');
   if(theme)url.searchParams.set('preview_theme_id',theme);
   enter.setAttribute('href',url.pathname+url.search+url.hash);
  }
 }catch{enter.setAttribute('aria-disabled','true');enter.removeAttribute('href')}
}
root.querySelector('[data-bf04-scroll]')?.addEventListener('click',()=>{
 const tiles=document.querySelector('[id$="__nude_tiles"]');
 const next=tiles||root.closest('.shopify-section')?.nextElementSibling;
 if(!next)return;
 next.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
});
})();